/* Thoson: las tres ayudas de orientacion del blog.
   Se carga con defer desde sections/thx-header.liquid, solo en las
   plantillas de articulo. No toca el texto ni mueve nada del contenido:
   solo anade una barra de progreso, marca en el indice la seccion que
   estas leyendo, y pone un boton para volver arriba.

   Los posts miden entre 33.000 y 49.000px de alto. Sin nada de esto, a
   mitad de un articulo no hay forma de saber cuanto llevas ni donde estas.
   ---------------------------------------------------------------- */
(function () {
  'use strict';

  var article = document.querySelector('.blog-article');
  if (!article) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----------------------------------------------------------------
     1. La barra de progreso.

     Mide contra el articulo, no contra la pagina, asi que llega al 100%
     cuando se acaba el texto y no cuando se acaba el footer.
     ---------------------------------------------------------------- */
  var bar = document.createElement('div');
  bar.className = 'thx-read-bar';
  bar.setAttribute('aria-hidden', 'true');
  var fill = document.createElement('span');
  bar.appendChild(fill);
  document.body.appendChild(bar);

  /* ----------------------------------------------------------------
     2. El boton de volver arriba.
     ---------------------------------------------------------------- */
  var toTop = document.createElement('button');
  toTop.type = 'button';
  toTop.className = 'thx-to-top';
  toTop.setAttribute('aria-label', /^es\b/i.test(document.documentElement.lang || '') ? 'Volver arriba' : 'Back to top');
  toTop.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><polyline points="6,14 12,8 18,14"></polyline></svg>';
  toTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });
  document.body.appendChild(toTop);

  var queued = false;

  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var rect = article.getBoundingClientRect();
      var span = rect.height - window.innerHeight;
      var done = span > 0 ? Math.min(1, Math.max(0, -rect.top / span)) : 0;
      fill.style.transform = 'scaleX(' + done.toFixed(4) + ')';
      bar.classList.toggle('is-on', rect.top < 0 && done < 1);
      toTop.classList.toggle('is-on', -rect.top > window.innerHeight);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* ----------------------------------------------------------------
     3. La seccion que estas leyendo, marcada en el indice.

     El indice ya viene escrito en el contenido con un enlace por seccion,
     asi que solo hay que emparejar cada enlace con su <section id> y
     encender el que toca. Sin esto el indice fijo es decoracion; con
     esto es un mapa.

     rootMargin deja activa la seccion cuyo titulo ya paso por debajo del
     header y todavia no ha salido por arriba.
     ---------------------------------------------------------------- */
  var toc = article.querySelector('.table-of-contents');
  if (!toc || !window.IntersectionObserver) return;

  var links = [];
  Array.prototype.forEach.call(toc.querySelectorAll('a[href^="#"]'), function (link) {
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    links.push({ link: link, target: target });
  });
  if (!links.length) return;

  var current = null;

  function mark(entry) {
    if (current === entry) return;
    if (current) current.link.classList.remove('is-current');
    current = entry;
    if (current) current.link.classList.add('is-current');
  }

  var seen = [];

  var watcher = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var row = links.filter(function (l) { return l.target === entry.target; })[0];
        if (!row) return;
        var at = seen.indexOf(row);
        if (entry.isIntersecting) {
          if (at === -1) seen.push(row);
        } else if (at > -1) {
          seen.splice(at, 1);
        }
      });

      if (!seen.length) return;
      /* Con dos secciones a la vista gana la de mas arriba, que es la que
         el lector esta terminando. */
      var top = seen.slice().sort(function (a, b) {
        return a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top;
      })[0];
      mark(top);
    },
    { rootMargin: '-14% 0px -70% 0px', threshold: 0 }
  );

  links.forEach(function (row) { watcher.observe(row.target); });
})();